export function formDataToObject(formData: FormData) {
  const object = {}
  formData.forEach((value, key) => {
    // Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value
      return
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]]
    }
    object[key].push(value)
  })
  return object
}

export function formDataObjectToAlgoliaFilters(formDataObject: {
  [key: string]: string[]
}) {
  const keys = Object.keys(formDataObject)
  return keys.reduce((prevValue, currentKey) => {
    return [...prevValue, formDataObject[currentKey]]
  }, [])
}
